window.addEventListener('DOMContentLoaded', function () {
    new ScrollHint('.js-scrollable');
});